import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var cookie = {
    selectors: {
        element:  '[data-cookie]',
        trigger:  '[data-cookie-trigger]',
        close:    '[data-cookie-close]'
    },
    init: function() {
        var self  = this,
        $elements = $( self.selectors.elements );

        var $close = $( self.selectors.close ),
        cookie = document.querySelector('.cookie-consent');

        disableBodyScroll( cookie );
        var closed = self.getCookie( 'cookie-consent-closed' );

        if ( closed !== '' ) {
            return;
        } else {
            $( document.body ).addClass( 'cookie-opened' );
        }

        $( self.selectors.element ).on( 'click', self.selectors.close, function(e) {
            e.preventDefault();

            enableBodyScroll( cookie );
            $( document.body ).removeClass( 'cookie-opened' );
            self.setCookie( 'cookie-consent-closed', '1', 1 );

            return false;
        } );
    },
    getCookie: function( cname ) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent( document.cookie );
        var ca = decodedCookie.split( ';' );
        for ( var i = 0; i < ca.length; i++ ) {
            var c = ca[ i ];
            while ( c.charAt( 0 ) == ' ' ) {
                c = c.substring( 1 );
            }
            if ( c.indexOf( name ) == 0 ) {
                return c.substring( name.length, c.length );
            }
        }
        return "";
    },
    setCookie: function( cname, cvalue, exdays ) {
        var d = new Date();
        d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

export { cookie };
